import {useState, useEffect, useContext} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AuthContext from "context/AuthContext";
import {publishEvent} from "core/eventsConnector";
import {useTranslation} from "react-i18next";
import AzureMapBase from "components/maps/azure/AzureMapBase";
import AzureMapPointOnClick from "components/maps/azure/AzureMapPointOnClick";

const AzureMapModal = ({show, setShow, title = "Mapa", initialLat = null, initialLng = null, onPositionSelect = null, azureMapsKey = null}) => {
    const {panel} = useContext(AuthContext);
    const [location, setlocation] = useState(null);
    const [mapCenter, setMapCenter] = useState(null);

    const {t: _Tf} = useTranslation("forms");

    useEffect(() => {
        if (show && initialLat && initialLng) {
            const position = [parseFloat(initialLat), parseFloat(initialLng)];
            setlocation(position);
            setMapCenter(position);
        } else if (show && panel.coords) {
            setMapCenter(panel.coords);
        }
    }, [show, initialLat, initialLng, panel.coords]);

    const handleMapClick = (coords) => {
        setlocation([coords.lat, coords.lng]);
    };

    const handleAccept = () => {
        if (location) {
            publishEvent("mapmodal:position:selected", {
                lat: location[0],
                lng: location[1],
            });

            if (onPositionSelect) {
                onPositionSelect(location[0], location[1]);
            }
        }
        setShow(false);
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Modal
            show={show}
            fullscreen={true}
            onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Seleccionar ubicación (Azure): {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <p className="text-muted">Haz click en el mapa para seleccionar una posición.</p>
                </div>
                <div>
                    {mapCenter && (
                        <AzureMapBase 
                            center={mapCenter} 
                            zoom={16} 
                            height="calc(100vh - 180px)"
                            subscriptionKey={azureMapsKey}
                        >
                            <AzureMapPointOnClick 
                                center={location || mapCenter}
                                onMapClick={handleMapClick}
                            />
                        </AzureMapBase>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {_Tf("labels.cancel")}
                </Button>
                <Button variant="primary" onClick={handleAccept} disabled={!location}>
                    {_Tf("labels.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AzureMapModal;
